var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5789 31V21.8597H14V18.3303H17.5789V15.7059C17.5789 12.629 19.7895 11 22.8421 11C24.3158 11 25.6842 11.0905 26 11.181V14.3484H23.7895C22.1053 14.3484 21.7895 15.0724 21.7895 16.0679V18.3303H25.8947L25.3684 21.8597H21.7895V31H17.5789Z","fill":"white","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"39","height":"39","rx":"19.5","stroke":"white","key":1})]);
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
